// NATIVE 
import React, { useState } from 'react';


// INSTALLED 
import Box from '@mui/material/Box';
import { useDispatch } from 'react-redux';


// CUSTOM 
import { Formik, Form } from 'formik';
import Step from '@mui/material/Step';
import { Link } from 'react-router-dom';
import Stepper from '@mui/material/Stepper';
import StepLabel from '@mui/material/StepLabel';
import { editCustomer, saveCustomer } from '../../store/customer';
import { SnackAlert } from '../../components/SnackAlert';
import { DatosClientes, DetallePlan  } from '../../components/cliente';
import { ModulosCliente } from '../../components/cliente/ModulosCliente';
import { MessagesDrawerRight } from '../../components/MessagesDrawerRight';
import { Breadcrumbs, Button, Card, Divider, Typography } from '@mui/material';
import validationSchema from '../../components/cliente/editar/formModels/validationSchema';
import formInitialValues from '../../components/cliente/editar/formModels/formInitialValues';
import editCustomerFormModel from '../../components/cliente/editar/formModels/editCustomerFormModel';
import { EditarDatosClientes } from '../../components/cliente/editar/EditarDatosClientes';
import { EditarModulosCliente } from '../../components/cliente/editar/EditarModulosCliente';




export const EditCustomer = () => {

  const dispatch = useDispatch();

  const { formId, formField } = editCustomerFormModel;

  const [data, setMsgErrors] = useState([]);
  const [alert_snack, setAlertSnack] = useState(false);
  
  const [activeStep, setActiveStep] = useState(0);
  const [percentaje_c_Company, setPercentajeCCompany] = useState(2);
  const currentValidationSchema = validationSchema[activeStep];
  

  // const steps: string[] = ['Informacion Basica', 'Permisos', 'Plan'];
  const steps: string[] = ['Informacion Basica', 'Permisos'];


  const isLastStep = activeStep === steps.length - 1;


  const lastStep = () => {


    if (activeStep == 0) return;
    
    setActiveStep(activeStep - 1);  
  }


  const _handleSubmit = (values:any, actions:any) => {

   

    if (isLastStep) {

      _submitForm(values, actions);

    } else {

      setActiveStep(activeStep + 1);
      actions.setTouched({});
      actions.setSubmitting(false);

    }

  }


  const  _renderStepContent = (steps: any) => {
    switch (steps) {
      case 0:
        return <EditarDatosClientes formField={formField} />;
      case 1:
        return <EditarModulosCliente  formField={formField} />;
    //   case 2:
    //     return <DetallePlan formField={formField} />;
    //   case 3:
      default:
        return <div>Not Found</div>; 
    }
  }



  const _submitForm = async(values:any, actions:any) => {

    
    actions.setSubmitting(true);

    const response = await dispatch( editCustomer(values, setPercentajeCCompany) );

    if (!response.ok) {

         if ( response.errors && response.errors.message.constructor === Array && response.errors.message.length > 0 ) {
              setMsgErrors(response.errors.message);
              return false;
         } 
    }

    if (response.ok) {
      setAlertSnack(true);
    }
    setActiveStep(0);
    actions.resetForm();
    actions.setSubmitting(false);
  }


  return (
    <Box sx={{ width: '100%' }}>
     
    <MessagesDrawerRight data={data} title={''} />
  
  
    <SnackAlert open={alert_snack} onclick={setAlertSnack} text={'Empresa creada con exito'} severity={"success"}/>
  
  

  <Typography fontSize={25} color="textPrimary" sx={{ fontWeight: 700 }}>Editar Cliente</Typography>
    <Breadcrumbs aria-label="breadcrumb" sx={{ padding: 2 }}>
        <Typography color="textPrimary" sx={{ fontWeight: 700 }}>Manager</Typography>
        <Link color="inherit" to="/manager/clientes">
          Listar Clientes
        </Link>
        <Typography color="textPrimary">Editar Cliente</Typography>
    </Breadcrumbs>
  <Divider sx={{ marginBottom: 3 }}/>
       
  
  
  <Stepper activeStep={activeStep}>
    {steps.map((label:any, index:any) => {
      const labelProps: {
        optional?: React.ReactNode;
        error?: boolean;
      } = {};
      // if (isStepFailed(index)) {
      //   labelProps.optional = (
      //     <Typography variant="caption" color="error">
      //       Faltan campos por diligenciar
      //     </Typography>
      //   );
      //   labelProps.error = true;
      // }

      return (
        <Step key={label}>
          <StepLabel {...labelProps}>{label}</StepLabel>
        </Step>
      );
    })}
  </Stepper>

     <Formik
        initialValues={formInitialValues}
        validationSchema={currentValidationSchema}
        onSubmit={_handleSubmit}
      >
     <Card style={{ marginTop: 50,  padding: 20}}>
       <Form id={formId}>
         {_renderStepContent(activeStep)}
        <div style={{ display: 'flex', justifyContent: 'end', marginTop: 25}}>
          

          {
            activeStep > 0 && <Button
                                style={{margin:5}}
                                variant="contained"
                                onClick={lastStep}
                                color="primary">
                                Atras
                              </Button>
          }
          <Button
              // disabled={isSubmitting}
              style={{margin:5}}
              type="submit"
              variant="contained"
              color={ isLastStep ? "success" : "primary"}
            >
              {isLastStep ? "Crear Cliente" : "Siguiente"}
          </Button>

          
        </div>
        </Form>
     </Card>
     
     </Formik>
</Box>
  )
}
